<div>
<h4 style="text-align: center">Fail Reasons </h4>
<div style="border: 1px solid white;" *ngIf = "responsibleTrades.length > 1">
  <h5 style="text-align: center;">Responsible Trades</h5>
    <div style="display:flex;">
      <div *ngFor="let trade of responsibleTrades">
        <div style="text-align: center">
          <ul>{{trade}}</ul>
        </div>
      </div>
    </div>
</div>
<div id ='top' style="position: relative;
text-align: center;
z-index: 1000;">
<h4 style="    font-size: 16px;
font-weight: 200;">Select one or more fail reasons from below</h4>
</div>



  <div style="height: 300px;">



    <div style="width:98%" style="height:350px; overflow-y:auto;">
      <br>
      <div>

        <div *ngFor="let fr of failreasons">
          <div class = "formitem-section" style="padding-right: 20px;">
            <mat-label style="white-space:normal;color: white; width:220px;">
              <p>{{fr.failreason}}</p>
            </mat-label>


            <mat-checkbox class="lgChk" (change)="addFailReason(fr.failreason)" style="width: 40px; height: 40px; padding-left: 35px; padding-bottom:15px; padding-right: 7px;" [checked]="selectedReasons.indexOf(fr.failreason) !== -1"></mat-checkbox>
            <!-- <mat-checkbox (change)="updateFailReason($event)" style="padding-left: 5px; padding-right: 7px;"></mat-checkbox> -->
          </div>
        </div>

      </div>
      </div>

  </div>

</div>

<div style="position: absolute;
bottom: 10%; right:10%;">
  <button style="background: #8cc63f;
    font-size: 24px;
    font-weight: 300;
    border: 0px;
    border-radius: 7px;
    width: 200px;
    color: white;" (click)="updateFailReason()">Done</button>
</div>
